import Vue from "vue";
import App from "./App.vue";
const moment = require("moment");
import Meta from "vue-meta";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Aos from "aos";
import "aos/dist/aos.css";

export const Bus = new Vue();

if (i18n.locale === "ar") {
    import("./assets/styles/rtl.css");

    moment.defineLocale("ar-sa-mine", {
        parentLocale: "ar-sa",
        preparse: function (string) {
            return string;
        },
        postformat: function (string) {
            return string;
        },
    });
}

Vue.use(Meta);

// Vue.config.errorHandler = (err, vm, info) => {

// store.dispatch('slack', {
//     name: vm.$options.name,
//     err: err
// })

//   };

// Adding flag icons
import "flag-icon-css/css/flag-icon.min.css";

import Print from "vue-print-nb";

Vue.use(Print);

import excel from "vue-excel-export";

Vue.use(excel);

import ToggleButton from "vue-js-toggle-button";

Vue.use(ToggleButton);

Vue.use(require("vue-moment"), {
    moment,
});

Vue.moment().locale(i18n.locale);

import VueNumber from "vue-number-animation";

Vue.use(VueNumber);

import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);

// Adding Buefy as our CSS Framework
import Buefy from "buefy";

//import material design icons
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Buefy, { defaultIconPack: "mdi" });

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import VueTelInput from "vue-tel-input";
Vue.use(VueTelInput);

//event bus
export const globalEvent = new Vue();

Vue.config.productionTip = false;

new Vue({
    created() {
        Aos.init({
            duration: 1000,
            delay: 100,
            once: true,
        });
    },
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
